// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3jmsk","alert":"SettungsInbox_alert__1gP5v"};